import { render, staticRenderFns } from "./DataTableV2Title.html?vue&type=template&id=2ec77b38&external"
import script from "./DataTableV2Title.js?vue&type=script&lang=js&external"
export * from "./DataTableV2Title.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2Title.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports